import { render, staticRenderFns } from "./StockInventoryRequirementsListDialog.vue?vue&type=template&id=2c240412"
import script from "./StockInventoryRequirementsListDialog.vue?vue&type=script&lang=js"
export * from "./StockInventoryRequirementsListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports